<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'结束培训':'结束培训'" :visible.sync="dialog" @close="unShowClick()" width="40%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="线下签到表" prop="name" :label-width="formLabelWidth">
					<el-radio-group v-model="radio">
						<el-radio :label="3">无线下签到表</el-radio>
						<el-radio :label="6">导入签到表</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="" v-if="radio == 6" :label-width="formLabelWidth">
					<el-upload class="upload-demo" drag :limit='1' :file-list='fileList' accept='.xls,.xlsx'
						:http-request='httpRequest' action='' :auto-upload="false" ref="upload" multiple>
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<div class="el-upload__tip" slot="tip">支持扩展名：.excel，请上传维护过后的《报名用户》表</div>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="TrainFinish('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		TrainFinish,
	} from '@/api/train'
	import UploadFile from "@/components/UploadFile"
	import baseUrl from '@/configs/baseUrl.js'
	import {
		imgDomain,
		urlDomain
	} from '@/configs/env';

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			UploadFile
		},
		data() {
			return {
				urlDomain,
				radio: 3,
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					file: '',
					train_uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					file: [{
						required: true,
						message: '请上传文件',
						trigger: 'blur'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [{
						id: 1,
						name: '用户'
					},
					{
						id: 2,
						name: '管理员'
					},
				],
				fileList: []
			}
		},
		mounted() {},
		methods: {
			async httpRequest(file) {
				console.log(file,9123)
				this.addBody.file = file.file
			},
			uploadSuccess(res, file) {
				this.addBody.file = imgDomain + res.result
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			TrainFinish(formName) {
				if(this.radio==6){
					this.$refs.upload.submit();
				}
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().TrainFinish()
						} else {
							this.network().TrainFinish()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					TrainFinish: async () => {
						if (this.radio == 6 && !this.addBody.file) {
							return this.$message.error('请上传文件')
						}
						const formData = new FormData();
						formData.append("file", this.addBody.file)
						formData.append("train_uuid", this.addBody.train_uuid)
						const {
							status,
							data
						} = await TrainFinish(formData)
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('已结束')
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.addBody.train_uuid = val.uuid
					this.isEdit = true;
				} else {
					this.addBody.train_uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>